module.exports = __webpack_public_path__ + "static/media/call_auth_guide.f9f5fd3d.svg";